export async function downloadUriSameOrigin(
    filename: string,
    uri: string,
    credentials: RequestCredentials = "include"
) {
    async function toDataURL(url: string) {
        const blob = await fetch(url, { credentials }).then((res) => res.blob())
        return URL.createObjectURL(blob)
    }
    const element = document.createElement("a")
    element.setAttribute("href", await toDataURL(uri))
    element.setAttribute("download", filename)
    element.style.display = "none"
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
}

export function download(filename: string, type: string, text: string) {
    downloadUri(filename, `data:${type},` + encodeURIComponent(text))
}

/**
 * Download any URI for the user
 * @param filename name of the file to show the user
 * @param uri of the resource to download
 */
export async function downloadUri(filename: string, uri: string) {
    const element = document.createElement("a")
    element.setAttribute("href", uri)
    element.setAttribute("download", filename)
    element.setAttribute("target", "_blank")
    element.style.display = "none"
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
}

/**
 * Download any {@link Blob} for the user
 * @param filename name of the file to show the user
 * @param blob the blob to download
 */
export async function downloadBlob(filename: string, blob: Blob) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = filename
    a.style.display = "none"
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
}
